import ApiClient from './ApiClient'

const client = new ApiClient()

export default {
  /**
   * 受賞者情報を取得
   */
  me (condition = null) {
    return client.get('me', condition)
  },
  /**
   * 一時トークンからセッショントークンを取得
   */
  exchangeToken (temporary_token, condition = null) {
    return client.get(`me/exchange_token?temporary_token=${temporary_token}`, condition)
  }
}
